import React, { useContext } from 'react';
import CustomerStore from './CustomerStore';
import { HeaderDynamicContext } from '../../../../contexts/HeaderDynamicData/HeaderDynamicData';

function CustomerStoreVM(props) {
  const { customerStore } = useContext(HeaderDynamicContext);
  return <CustomerStore {...props} customerStore={customerStore} />;
}

export default CustomerStoreVM;
